import React, { useState } from 'react';
import { connect } from 'react-redux';

import clsx from 'clsx';

import BobConfirmButton from '../../../components/BobConfirmButton';
import BobCancelButton from '../../../components/BobCancelButton';
import BobModal from '../../../components/BobModal';

import * as BasAgentActions from '../../../actions/basAgentActions';

import * as classes from './DeleteBasAgentModal.module.css';

const DeleteBasAgentModal = ({
    activeNavCompany,
    agent,
    deleteBasAgent,
    setDeleteAgentModalOpen,
    ...props
}) => {

    const [isLoading, setIsLoading] = useState(false);

    const handleDeleteAgent = async () => {
        const agentId = agent.id;

        setIsLoading(true);
        let isDeleted = await deleteBasAgent(activeNavCompany.id, agentId, agent);
        setIsLoading(false);

        if (isDeleted) setDeleteAgentModalOpen(false);
    };

    return (
        <BobModal
            title={'Delete Agent'}
            hidebuttons={true}
            headerOverride={classes.HeaderOverride}
            isRemoveFooter={true}
            onClose={() => setDeleteAgentModalOpen(false)}
        >
            <div className={classes.ModalBody}>
                <div className={classes.NamePanel}>
                    <div className={classes.Title}>
                        Agent Name
                    </div>
                    <div className={classes.IntegrationName}>
                        {agent.name}
                    </div>
                </div>
                <div className={classes.InfoPanel}>
                    <i className={clsx('fas fa-info-circle', classes.HelpIcon)} />
                    <span className={classes.InfoText}>
                        If a BAS agent is associated with this Agent Configuration,
                        the Serial Number will be released and will be available for assignment to a different Agent Configuration.
                        <p>
                            If you are just moving a BAS Agent to a different BAS,
                            then you can leave this Agent Configuration and unassign the BAS Agent.
                            This will allow you to assign a new BAS Agent at a later date to the current Agent Configuration.
                        </p>
                    </span>
                </div>
                <div className={classes.ConfirmationPanel}>
                    Are you sure you want to delete?
                </div>
                <div className={classes.ButtonPanel}>
                    <BobCancelButton
                        disabled={isLoading}
                        onClick={() => setDeleteAgentModalOpen(false)}
                        className={classes.CancelButton}
                        label={'No'}
                    />
                    <BobConfirmButton
                        disabled={isLoading}
                        onClick={() => handleDeleteAgent()}
                        className={isLoading ? classes.DisabledButtons : classes.Buttons}
                        label={'Yes'}
                        iconSize={15}
                        isLoading={isLoading}
                    />
                </div>
            </div>
        </BobModal>
    );
};

const mapStateToProps = state => ({
    activeNavCompany: state.bob.activeNavCompany,
});

const mapDispatchToProps = {
    ...BasAgentActions
};

export default connect(mapStateToProps, mapDispatchToProps)(DeleteBasAgentModal);
